import React, { useEffect } from 'react';
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import standard from '../../../../images/DP/standard.jpg'
import absorbing from '../../../../images/DP/absorbant_details.webp'
import box from '../../../../images/DP/eggbox1.webp'
import { useTranslation } from "react-i18next";


const Testimonial1_content = [
    {
        image: standard,
        author: 'Standard',
        description:
            'Les barquettes de DEVPACK se distinguent par leur faible poids et leur grande stabilité. Nous proposons une variété de modèles standard dans différentes tailles, profondeurs et couleurs.',

    },
    {
        image: absorbing,
        author: 'Absorbant',
        description:
            'Les barquettes Absorbant de DP conviennent au conditionnement des aliments frais ayant une durée de conservation courte. Elles sont utilisées pour le conditionnement sous film étirable ou en système flowpack.',

    },
    {
        image: box,
        author: 'Boxes',
        description:
            'Nos box Oeufs sont idéales pour vos oeufs  grâce à leur système Easy Open. Elles se caractérisent non seulement par leur système Easy Open  mais aussi par leur légèreté.',

    },

]
const Testmonial = ({ lang, SetLang }) => {
    const [t, i18n] = useTranslation('traduction');

    const settings = {
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true
    };
    useEffect(() => {
        // Aos.init({
        //     duration: 1500,
        //     disable: 'mobile',
        //     once: true,
        //     mirror: false
        // });
        i18n.changeLanguage(lang);
    }, [i18n, lang]);
    return (
        <>
            <Slider {...settings} className="testimonial-box-carousel btn-style-1 client-btn">
                {Testimonial1_content.map((item, id) => (
                    <div class="item">
                        <div class="testimonial-11 testimonial-box">
                            <div class="testimonial-pic">
                                <img src={item.image} alt="" />
                            </div>
                            <div class="testimonial-detail quote-left quote-right">
                                <div class="testimonial-text">
                                    <p>{t(item.description)}</p>
                                </div>
                                <h5 class="testimonial-name text-primary m-t0 m-b5">{t(item.author)}</h5>
                                <span class="testimonial-position">{t(item.designation)}</span>
                            </div>
                        </div>
                    </div>
                ))}
            </Slider>

        </>
    )
}
export default Testmonial;